import { render, staticRenderFns } from "./StampaReportSeriali.vue?vue&type=template&id=0dd94688&scoped=true&"
import script from "./StampaReportSeriali.vue?vue&type=script&lang=js&"
export * from "./StampaReportSeriali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd94688",
  null
  
)

export default component.exports